module.exports = __webpack_public_path__ + "img/triangle1.365f6c8f.svg";